import React from 'react'

export default function EditProject() {
  return (
    <div>EditProject</div>
  )
}
